// ---------- HeroSlider.js ----------
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from "react-icons/bs";
import "./home.css";

const HeroSlider = () => {
  const heroSlides = [
    { img: "/e82.png" },
    { img: "/78.png" },
    { img: "/e85.png" },
     { img: "/e99.png" },
  ];

  const [index, setIndex] = useState(1);
  const [transitionEnabled, setTransitionEnabled] = useState(true);
  const heroRef = useRef(null);
  const intervalRef = useRef(null);

  // Clone last & first for seamless loop
  const slides = [
    heroSlides[heroSlides.length - 1],
    ...heroSlides,
    heroSlides[0],
  ];

  const nextSlide = () => setIndex((prev) => prev + 1);
  const prevSlide = () => setIndex((prev) => prev - 1);
  const navigate = useNavigate();

  /* ===============================
     AUTO SLIDER WITH TAB VISIBILITY
  =============================== */
  useEffect(() => {
    const startSlider = () => {
      if (!intervalRef.current) {
        intervalRef.current = setInterval(nextSlide, 4000);
      }
    };

    const stopSlider = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopSlider();
      } else {
        startSlider();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    startSlider();

    return () => {
      stopSlider();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  /* ===============================
     LOOP JUMP HANDLER
  =============================== */
  useEffect(() => {
    const slider = heroRef.current;
    if (!slider) return;

    const handleTransitionEnd = () => {
      if (index === slides.length - 1) {
        setTransitionEnabled(false);
        setIndex(1);
      } else if (index === 0) {
        setTransitionEnabled(false);
        setIndex(slides.length - 2);
      }
    };

    slider.addEventListener("transitionend", handleTransitionEnd);
    return () =>
      slider.removeEventListener("transitionend", handleTransitionEnd);
  }, [index, slides.length]);

  /* ===============================
     RE-ENABLE TRANSITION
  =============================== */
  useEffect(() => {
    if (!transitionEnabled) {
      const t = setTimeout(() => setTransitionEnabled(true), 80);
      return () => clearTimeout(t);
    }
  }, [transitionEnabled]);

  /* ===============================
     IMAGE LOAD (PREVENT FLASH)
  =============================== */
  const handleImgLoad = (e) => {
    e.currentTarget.classList.add("loaded");
  };

  return (
    <div className="hero">
      <div
        className="hero-slides"
        ref={heroRef}
        style={{
          transform: `translateX(-${index * 100}%)`,
          transition: transitionEnabled ? "transform 0.8s ease" : "none",
        }}
      >
        {slides.map((slideItem, idx) => (
          <div className="hero-slide" key={idx}>
            <img
              src={slideItem.img}
              alt={`Slide ${idx}`}
              onLoad={handleImgLoad}
              loading="eager"
            />
            <div className="hero-bottom-box">
              <p>{slideItem.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* ACTION BUTTONS */}
      <div className="hero-buttons">
        <button
          className="hero-button"
          onClick={() => navigate("/our-services", { state: { scrollTo: "insurance" } })}
        >
          INSURANCE
          <img src="/family.png" alt="Insurance" className="button-logo" />
        </button>

        <button
          className="hero-button"
          onClick={() => navigate("/our-services", { state: { scrollTo: "loans" } })}
        >
          LOAN
          <img src="/loan.png" alt="Loan" className="button-logo" />
        </button>

        <button
          className="hero-button"
          onClick={() => navigate("/our-services", { state: { scrollTo: "mutual" } })}
        >
         MUTUAL FUNDS & SIP
          <img src="/money.png" alt="Mutual Funds" className="button-logo" />
        </button>
      </div>

      {/* ARROWS */}
      <BsArrowLeftCircleFill
        onClick={prevSlide}
        className="arrow arrow-left"
        style={{ left: "20px" }}
      />
      <BsArrowRightCircleFill
        onClick={nextSlide}
        className="arrow arrow-right"
        style={{ right: "20px" }}
      />
    </div>
  );
};

export default HeroSlider;
